<template>
  <form class="pb-60" autocomplete="off" @submit.prevent="handleSubmit">
    <input type="text" name="fake_username" autocomplete="username" class="d-none" tabindex="-1" />
    <input type="password" name="fake_password" autocomplete="new-password" class="d-none" tabindex="-1" />
    <div class="row">
      <div class="col-xxl-3 col-xl-4 col-lg-4">
        <div class="form-group">
          <label class="d-block fs-14 text-black mb-2">{{ $t(`${i18nScope}.profile_image`) }}</label>
          <div class="card upload-gallery border-0 rounded-1 p-xxl-30 p-4">
            <div class="file-upload text-center position-relative mb-35">
              <img
                :src="previewAvatarUrl"
                :alt="$t(`${i18nScope}.profile_image_alt`)"
                class="profile-preview mb-3"
              />
              <input
                ref="avatarInput"
                type="file"
                class="d-none"
                accept="image/*"
                @change="handleAvatarChange"
              />
              <p class="d-block text-optional fs-14 mb-2">
                {{ $t(`${i18nScope}.profile_image_caption`) }}
              </p>
              <button
                type="button"
                class="btn style-two btn-sm"
                @click="openAvatarPicker"
              >
                {{ $t(`${i18nScope}.select_image`) }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xxl-9 col-xl-8 col-lg-8">
        <div class="row gx-xxl-6">
          <div class="col-lg-6">
            <div class="form-group mb-25">
              <label class="d-block fs-14 text-black mb-2">{{ $t(`${i18nScope}.first_name`) }}</label>
              <input
                v-model="form.first_name"
                type="text"
                class="w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title"
                :placeholder="$t(`${i18nScope}.first_name`)"
                required
              />
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group mb-25">
              <label class="d-block fs-14 text-black mb-2">{{ $t(`${i18nScope}.last_name`) }}</label>
              <input
                v-model="form.last_name"
                type="text"
                class="w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title"
                :placeholder="$t(`${i18nScope}.last_name`)"
              />
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group mb-25">
              <label class="d-block fs-14 text-black mb-2">{{ $t(`${i18nScope}.username`) }}</label>
              <input
                v-model="form.username"
                type="text"
                class="w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title"
                :placeholder="$t(`${i18nScope}.username`)"
                required
              />
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group mb-25">
              <label class="d-block fs-14 text-black mb-2">{{ $t(`${i18nScope}.phone_number`) }}</label>
              <input
                v-model="form.phone"
                type="text"
                class="w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title"
                :placeholder="$t(`${i18nScope}.phone_number`)"
                required
              />
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group mb-25">
              <label class="d-block fs-14 text-black mb-2">{{ $t(`${i18nScope}.email`) }}</label>
              <input
                v-model="form.email"
                type="email"
                class="w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title"
                :placeholder="$t(`${i18nScope}.email`)"
                required
              />
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group mb-25">
              <label class="d-block fs-14 text-black mb-2">{{ $t(`${i18nScope}.company`) }}</label>
              <input
                v-model="form.company"
                type="text"
                class="w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title"
                :placeholder="$t(`${i18nScope}.company`)"
              />
            </div>
          </div>

          <div class="col-lg-12">
            <div class="form-group mb-25">
              <label class="d-block fs-14 text-black mb-2">{{ $t(`${i18nScope}.address`) }}</label>
              <textarea
                v-model="form.address"
                cols="30"
                rows="6"
                :placeholder="$t(`${i18nScope}.address`)"
                class="d-block w-100 bg-white border-0 rounded-1 resize-none fs-14 text-title"
              ></textarea>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group mb-25">
              <label class="d-block fs-14 text-black mb-2">{{ $t(`${i18nScope}.current_password`) }}</label>
              <input
                v-model="passwordForm.current_password"
                type="password"
                name="current_password"
                autocomplete="new-password"
                class="w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title"
                :placeholder="$t(`${i18nScope}.current_password`)"
              />
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group mb-25">
              <label class="d-block fs-14 text-black mb-2">{{ $t(`${i18nScope}.new_password`) }}</label>
              <input
                v-model="passwordForm.new_password"
                type="password"
                name="new_password"
                autocomplete="new-password"
                class="w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title"
                :placeholder="$t(`${i18nScope}.new_password`)"
              />
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group mb-25">
              <label class="d-block fs-14 text-black mb-2">{{ $t(`${i18nScope}.confirm_new_password`) }}</label>
              <input
                v-model="passwordForm.new_password_confirmation"
                type="password"
                name="new_password_confirmation"
                autocomplete="new-password"
                class="w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title"
                :placeholder="$t(`${i18nScope}.confirm_new_password`)"
              />
            </div>
          </div>

          <div class="col-12">
            <button
              class="btn style-one transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16"
              type="submit"
              :disabled="isSubmitting"
            >
              <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
              {{ isSubmitting ? $t(`${i18nScope}.updating_profile`) : $t(`${i18nScope}.update_profile`) }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script lang="ts">
import { computed, defineComponent, onBeforeUnmount, onMounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import Swal from "sweetalert2";

import userService from "../../../services/user";
import { useCurrentUser, type CurrentUserProfile } from "../../../composables/useCurrentUser";
import defaultAvatarImg from "../../../assets/img/users/user-default.jpg";
import { buildAssetUrl, buildStorageAssetUrl } from "../../../utils/settings";

type ProfileForm = {
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  phone: string;
  address: string;
  company: string;
};

type PasswordForm = {
  current_password: string;
  new_password: string;
  new_password_confirmation: string;
};

const createEmptyForm = (): ProfileForm => ({
  first_name: "",
  last_name: "",
  username: "",
  email: "",
  phone: "",
  address: "",
  company: "",
});

export default defineComponent({
  name: "MyProfile",
  setup() {
    const { t } = useI18n();
    const { currentUser, fetchCurrentUser, cacheCurrentUser } = useCurrentUser();
    const i18nScope = "my_profile_page";
    const isSubmitting = ref(false);
    const avatarInput = ref<HTMLInputElement | null>(null);
    const selectedAvatarFile = ref<File | null>(null);
    const previewObjectUrl = ref<string | null>(null);
    const form = reactive<ProfileForm>(createEmptyForm());
    const passwordForm = reactive<PasswordForm>({
      current_password: "",
      new_password: "",
      new_password_confirmation: "",
    });

    const avatarUrl = computed(() => {
      const avatar = currentUser.value?.avatar;
      if (!avatar) {
        return defaultAvatarImg;
      }

      if (String(avatar).startsWith("http")) {
        return String(avatar);
      }

      if (String(avatar).startsWith("uploads/")) {
        return buildAssetUrl(String(avatar));
      }
      return buildStorageAssetUrl(String(avatar));
    });

    const previewAvatarUrl = computed(() => previewObjectUrl.value || avatarUrl.value);

    const fillForm = (user: CurrentUserProfile | null) => {
      form.first_name = String(user?.first_name || "");
      form.last_name = String(user?.last_name || "");
      form.username = String(user?.username || "");
      form.email = String(user?.email || "");
      form.phone = String(user?.phone || "");
      form.address = String(user?.address || "");
      form.company = String(user?.company || "");
    };

    const loadProfile = async () => {
      const profile = await fetchCurrentUser(true);
      fillForm(profile);
    };

    const resetPasswordForm = () => {
      passwordForm.current_password = "";
      passwordForm.new_password = "";
      passwordForm.new_password_confirmation = "";
    };

    const openAvatarPicker = () => {
      avatarInput.value?.click();
    };

    const clearPreviewObjectUrl = () => {
      if (previewObjectUrl.value) {
        URL.revokeObjectURL(previewObjectUrl.value);
        previewObjectUrl.value = null;
      }
    };

    const handleAvatarChange = (event: Event) => {
      const target = event.target as HTMLInputElement | null;
      const file = target?.files?.[0] || null;

      clearPreviewObjectUrl();
      selectedAvatarFile.value = file;

      if (file) {
        previewObjectUrl.value = URL.createObjectURL(file);
      }
    };

    const handleSubmit = async () => {
      if (!currentUser.value?.id) {
        await Swal.fire(t(`${i18nScope}.error`), t(`${i18nScope}.unable_to_identify_user`), "error");
        return;
      }

      if (
        (passwordForm.current_password || passwordForm.new_password || passwordForm.new_password_confirmation) &&
        (!passwordForm.current_password || !passwordForm.new_password || !passwordForm.new_password_confirmation)
      ) {
        await Swal.fire(t(`${i18nScope}.error`), t(`${i18nScope}.complete_password_fields`), "error");
        return;
      }

      if (
        passwordForm.new_password &&
        passwordForm.new_password !== passwordForm.new_password_confirmation
      ) {
        await Swal.fire(t(`${i18nScope}.error`), t(`${i18nScope}.password_confirmation_mismatch`), "error");
        return;
      }

      isSubmitting.value = true;

      try {
        const payload = new FormData();
        payload.append("first_name", form.first_name);
        payload.append("last_name", form.last_name);
        payload.append("username", form.username);
        payload.append("email", form.email);
        payload.append("phone", form.phone);
        payload.append("address", form.address);
        payload.append("company", form.company);
        payload.append("warehouse_id", String(currentUser.value.warehouse_id ?? ""));
        payload.append("warehouse_name", String(currentUser.value.warehouse_name ?? ""));
        payload.append("branch_name", String(currentUser.value.branch_name ?? ""));
        payload.append("biller_name", String(currentUser.value.biller_name ?? ""));
        payload.append("gender", String(Number(currentUser.value.gender || 0)));
        payload.append("active", String(Number(currentUser.value.active ?? 1)));
        payload.append("view_right", String(Number(currentUser.value.view_right ?? 1)));
        payload.append("edit_right", String(Number(currentUser.value.edit_right ?? 1)));

        if (selectedAvatarFile.value) {
          payload.append("avatar", selectedAvatarFile.value);
        }

        const updatedProfile = await userService.updateCurrentProfile(currentUser.value.id, payload);

        let refreshedProfile: CurrentUserProfile = {
          ...(currentUser.value || {}),
          ...updatedProfile,
        };

        if (passwordForm.current_password && passwordForm.new_password) {
          await userService.changeCurrentPassword(currentUser.value.id, {
            current_password: passwordForm.current_password,
            new_password: passwordForm.new_password,
            new_password_confirmation: passwordForm.new_password_confirmation,
          });
        }

        cacheCurrentUser(refreshedProfile);
        fillForm(refreshedProfile);
        resetPasswordForm();
        selectedAvatarFile.value = null;
        clearPreviewObjectUrl();

        if (avatarInput.value) {
          avatarInput.value.value = "";
        }

        await Swal.fire(t(`${i18nScope}.success`), t(`${i18nScope}.profile_updated_successfully`), "success");
      } catch (error: unknown) {
        console.error("Failed to update profile:", error);
        const err = error as { response?: { data?: { message?: string } }; message?: string };
        const message = err.response?.data?.message || err.message || t(`${i18nScope}.failed_to_update_profile`);
        await Swal.fire(t(`${i18nScope}.error`), message, "error");
      } finally {
        isSubmitting.value = false;
      }
    };

    onMounted(loadProfile);
    onBeforeUnmount(clearPreviewObjectUrl);

    return {
      i18nScope,
      avatarInput,
      previewAvatarUrl,
      form,
      passwordForm,
      isSubmitting,
      handleAvatarChange,
      openAvatarPicker,
      handleSubmit,
    };
  },
});
</script>

<style lang="scss" scoped>
.upload-gallery {
  .file-upload {
    padding: 40px 20px;
    border: 1.5px dashed #a8acb2;
    text-align: center;
    border-radius: 4px;
  }
}

.profile-preview {
  width: 96px;
  height: 96px;
  border-radius: 16px;
  object-fit: cover;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

@media only screen and (min-width: 1400px) {
  .upload-gallery {
    .file-upload {
      padding: 40px 15px 35px;
    }
  }
}
</style>
